<template>
	<div>
		<dialog-form
			:dialogVisible="showDoalog"
			:attributes="attributes"
			:showBtn="false"
			@close:dialogVisible="close"
			class="dialog"
		>
			<div slot="main">
				<client-module moduletitle="KPI设置">
					<div class="kpi-monitor">
						<form-combination
							ref="formName"
							:form-data="formData"
							:formStyle="formStyle"
						></form-combination>
						<el-button class="btn-save" @click="saveCost">保存</el-button>
					</div>
				</client-module>
				<client-module moduletitle="预警设置">
					<filter-panel :data="groups" @search="filterChange" :hideResult="true"></filter-panel>
					<data-list
						style="margin-top: 10px;"
						height="400px"
						:data="data"
						:columns="columns"
						@sort-change="sortChange"
					></data-list>
				</client-module>
			</div>
		</dialog-form>
	</div>
</template>

<script>
import dialogForm from '@/components/dialogForm/dialogForm.vue';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
const dataList = listPageCreate({
	searchConfig: {
		api: api.googleAds.monitoringRuleConfig,
		method: 'POST',
	},
	getQuery(obj, that) {
		return _.assign(obj, { serviceId: that.serviceId });
	},
});
export default {
	mixins: [dataList],
	props: {
		serviceId: {
			type: String,
		},
		showDoalog: {
			type: Boolean,
			default: true,
		},
		attributes: {
			type: Object,
			default() {
				return { width: '50%', destroy: true };
			},
		},
		formData: {
			type: Object,
			default() {
				return {};
			},
		},
		groups: {
			type: Object,
			default() {
				return {};
			},
		},
		columns: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			formStyle: {
				display: 'flex',
				'justify-content': 'space-between',
				'align-items': 'center',
			},
		};
	},
	methods: {
		close() {
			// 同步父组件数据
			this.$emit('close:dialogVisible', false);
		},
		saveCost() {
			this.$refs.formName.validate(async val => {
				if (val) {
					this.$emit('saveCost');
				}
			});
		},
	},
	components: { dialogForm, clientModule, formCombination, filterPanel },
};
</script>

<style lang="scss" scoped>
.dialog {
  .module-main {
    .kpi-monitor {
      display: flex;
      align-items: center;
      // justify-content: flex-start;
      .btn-save {
        height: 36px;
        margin-left: 16px;
        margin-top: 10px;
        padding: 10px 16px;
      }
    }

    .form_combination {
      width: 100%;
      padding-top: 30px;

      .el-form {
        border: 1px solid orange;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
